import { AutocompleteUser, Place } from '../types';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';
import { AxiosError } from 'axios';

import axios from './axios';
import { queryClient } from 'src/core/react-query';

export interface UseMutatePlaceVariables {
  name: string | null;
  description: string | null;
  is_active: boolean;
  is_public: boolean;
  private_for: AutocompleteUser | null;
}

export interface UseMutatePlaceData extends Place {}

export function useMutatePlace(id: number) {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<
    UseMutatePlaceData,
    AxiosError<never>,
    UseMutatePlaceVariables
  >(
    (variables) => {
      const data = variables;

      return axios
        .put<UseMutatePlaceData>(`/posht/yashar/meeting-places/${id}/`, data)
        .then((res) => res.data);
    },
    {
      onError: () => {
        enqueueSnackbar(t('errors.unknown'), { variant: 'error' });
      },
      onSettled: () => {
        queryClient.invalidateQueries(['place', id]);
        queryClient.invalidateQueries('places');
      },
      onSuccess: () => {
        enqueueSnackbar(t('operation.successful'), { variant: 'success' });
      },
    },
  );
}
